import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled, { css } from 'styled-components';

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${SPACING.SMALL_2};
`;

export const FlexVerticalContent = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
`;

export const Content = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 3fr) minmax(0, 3fr) minmax(0, 3fr);
    gap: ${SPACING.MEDIUM};
`;

const gridStyles = css`
    display: flex;
    flex-direction: column;
    gap: ${SPACING.SMALL_3};
`;

export const ContentGrid = styled.div`
    ${gridStyles}
`;

export const ContentGridWithBorder = styled.div`
    ${gridStyles}
    border-left: 1px solid ${Colors.gray30};
    padding-left: ${SPACING.MEDIUM};
`;

export const HorizontalLine = styled.div`
    height: 1px;
    background: ${Colors.gray30};
`;
